import { authManager } from '@/utils/login';

export class OidcService {
    public getAccessToken(): Promise<string> {
        return new Promise((resolve, reject) => {
            authManager.getUser()
                .then((user) => {
                    if (user !== null) {
                        resolve(user.access_token);
                    } else {
                        reject(null);
                    }
                }).catch((error) => {
                console.log('Error in getting user:', error.message);
                reject(null);
            });
        });
    }
}
